import * as React from "react";
import { useContext, useEffect, useMemo } from "react";
import loadAsync from "routing/loadAsync";
import ErrorPage from "components/errors/ErrorPage";
import Button from "components/bootstrap/Button";
import ServerUnavailablePage from "pages/ServerUnavailablePage";
import "theme/bootstrap.less";
import CurrentUser from "logic/users/CurrentUser";
import Session from "logic/session/Session";
import { validate } from "logic/session/SessionApi";
import useExternalStore from "hooks/useExternalStore";
import ServerAvailabilityContext from "contexts/ServerAvailabilityContext";
import GraylogThemeProvider from "theme/GraylogThemeProvider";
import GlobalThemeStyles from "theme/GlobalThemeStyles";
import Notifications from "routing/Notifications";
const LoginPage = loadAsync(() => import(
  /* webpackChunkName: "LoginPage" */
  "pages/LoginPage"
));
const LoadingPage = loadAsync(() => import(
  /* webpackChunkName: "LoadingPage" */
  "pages/LoadingPage"
));
const LoggedInPage = loadAsync(() => import(
  /* webpackChunkName: "LoggedInPage" */
  "pages/LoggedInPage"
));
const SERVER_PING_TIMEOUT = 2e4;
const LoggedOutThemeProvider = ({ children }) => /* @__PURE__ */ React.createElement(GraylogThemeProvider, { userIsLoggedIn: false }, /* @__PURE__ */ React.createElement(GlobalThemeStyles, null), /* @__PURE__ */ React.createElement(Notifications, null), children);
const AppFacade = () => {
  const currentUser = useExternalStore(CurrentUser, (state) => state.currentUser);
  const loadError = useExternalStore(CurrentUser, (state) => state.loadError);
  const { server, ping } = useContext(ServerAvailabilityContext);
  const username = useExternalStore(Session, (state) => {
    var _a;
    return (_a = state.username) != null ? _a : "";
  });
  useEffect(() => {
    validate().catch(() => {
    });
  }, []);
  useEffect(() => {
    const interval = setInterval(ping, SERVER_PING_TIMEOUT);
    return () => clearInterval(interval);
  }, [ping]);
  const ThemeProvider = useMemo(
    () => server.up && username && currentUser ? React.Fragment : LoggedOutThemeProvider,
    [currentUser, server.up, username]
  );
  const content = useMemo(() => {
    if (server.up === false) {
      return /* @__PURE__ */ React.createElement(ServerUnavailablePage, { server });
    }
    if (!username) {
      return /* @__PURE__ */ React.createElement(LoginPage, null);
    }
    if (loadError) {
      return /* @__PURE__ */ React.createElement(ErrorPage, { title: "Loading your user failed", description: loadError.message, displayPageLayout: false }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: () => window.location.reload() }, "Reload page"));
    }
    if (!currentUser) {
      return /* @__PURE__ */ React.createElement(LoadingPage, { text: "We are preparing the web interface for you..." });
    }
    return /* @__PURE__ */ React.createElement(LoggedInPage, null);
  }, [currentUser, loadError, server, username]);
  return /* @__PURE__ */ React.createElement(ThemeProvider, null, content);
};
export default AppFacade;
